import { createStore } from 'vuex'

export default createStore({
    state: {
        apiUrl: 'https://'+location.hostname+'/games/services.php',
        // apiUrl: 'http://localhost/projets/Sami/games/services.php',
        
        waitingRequest: true,
        activeMobileLink: 0,
        accountCreated: false,
    },
    getters: {
    },
    mutations: {
        setRequestFalse(state) {
            state.waitingRequest = false;
        },
        setRequestTrue(state) {
            state.waitingRequest = true;
        },
        setActiveMobileLink(state, number) {
            state.activeMobileLink = number;
        },
        setAccountCreated(state, value) {
            state.accountCreated = value;
        },
    },
    actions: {
    },
    modules: {
    }
})